
import Cookies from 'universal-cookie';
import moment from 'moment';
import request from 'superagent';
import { alertActions , loadingActions } from '../_actions';
import { userService } from '../_services';
import { store } from '../_helpers/store';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export const utils = {
    FormatNumberLength , 
    CheckUser ,
    FormatTime , 
    Post , 
    Get , 
    toFormFields , 
    addZeroes
}

function Post (url , formBody , allowAnonymous){
    store.dispatch(showLoading());

    let token ;
    let authentication = store.getState().authentication;

    if(!allowAnonymous){
        token = authentication ? authentication.user.token : '' ;
    }

    return (
        request
        .post(url)
        .set('Content-Type', 'application/json')
        .set('Authorization' , `Bearer ${token}`)
        .send(formBody)
        .then(response=> {
            store.dispatch(hideLoading());

            return (response.body);
        })
        .catch( error => {
            store.dispatch(hideLoading());
            store.dispatch(alertActions.error(error.response));

            throw error;
        } )
    )
}

function Get (url , allowAnonymous ){
    store.dispatch(showLoading());
    
    let token ;
    let authentication = store.getState().authentication;

    if(!allowAnonymous){
        token = authentication ? authentication.user.token : '' ;
    }

    return (
        request
        .get(url)
        .set('Authorization' , `Bearer ${token}`)
        .then(response=> {
            store.dispatch(hideLoading());

            return (response.body);
        })
        .catch( error => {
            
            store.dispatch(hideLoading());
            store.dispatch(alertActions.error(error.response));

            throw error;
        })
    )
}


function FormatNumberLength(num, length) {
    var r = "" + (num ?  parseFloat(num).toFixed(0) : 0);
    while (r.length < length) {
        r = "0" + r;
    }
    return r;
}

function addZeroes(num) {
    // Convert input string to a number and store as a variable.
        var value = Number(num);      
    // Split the input string into two arrays containing integers/decimals
        var res = num.split(".");     
    // If there is no decimal point or only one decimal place found.
        if(res.length == 1 || res[1].length < 3) { 
    // Set the number to two decimal places
            value = value.toFixed(2);
        }
    // Return updated or original number.
    return value;
}

function CheckUser(){
    let user =  JSON.parse(localStorage.getItem('user')); 
 
    return user; 
 }

function FormatTime(seconds , isMinute){
    let min = 0 , hours = 0 , days = 0 ;
    let minutes ; 
    
    if(isMinute === true){
        minutes = seconds ;
    } 
    else {
        minutes = seconds / 60;
    }

    if(minutes){
        min = parseInt(minutes % 60);
        hours = parseInt(minutes / 60);
        days = parseInt(hours / 24);
        hours = hours - 24*days;
    }

    return {
        min : min , 
        hours : hours , 
        days : days 
    }
}

function toFormFields(json, prefix = "") {
    if (
      Object.prototype.toString.call( json ) === '[object Array]'
    ) {
      return json.reduce(
        (all, elem, index) => all.concat(toFormFields(elem, prefix + `[${index}]`)), []
      )
    } else if (Object.prototype.toString.call( json ) === '[object Object]') {
      return Object.keys(json).reduce(
        (all, key) => all.concat(toFormFields(json[key], prefix ? prefix + `[${key}]` : `${key}`)), []
      );
    } else {
      return [[prefix, json]]
    }
  };


// WEBPACK FOOTER //
// ./src/_helpers/utils.js